import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";

class deviceManagementDataAccess {
  deviceList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "DeviceManagement/getAll",
      parameters
    );
  };

  saveDeviceInfo = (payload: any) => {
    return commonDataAccess.postData("DeviceManagement/save/", payload);
  };

  getDeviceById = async (id: number) => {
    return await commonDataAccess.getData(`DeviceManagement/getById/${id}`, {});
  };


  deleteDeviceInfo = (ids: number | number[]) =>{
    if(Array.isArray(ids)){
      return commonDataAccess.postData("DeviceManagement/deleteAll", ids);
    }else{
      return commonDataAccess.deleteData(`DeviceManagement/delete/${ids}`);
    }
  }

}


export default new deviceManagementDataAccess();
